const UUID_REGEX =
	/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/

function isUuid(string?: string | null): boolean {
	if (!string) return false
	return Boolean(string.match(UUID_REGEX))
}

export { UUID_REGEX, isUuid }
